import environment from "environment";
// const host = environment.baseApiLambda;
const base = `//www.dreamchimney.com/api`;

export const urlChimneyProfile = base + "/tracks/profile";

export const getChimneyProfile = (axios, chimDir) => axios.get(`${urlChimneyProfile}/${encodeURIComponent(chimDir)}`);
export const getChimneyProfileTopTen = (axios, chimDir) => axios.get(`${urlChimneyProfile}/${encodeURIComponent(chimDir)}/topten`);
export const getChimneyProfileWishlist = (axios, chimDir) => axios.get(`${urlChimneyProfile}/${encodeURIComponent(chimDir)}/wishlist`);
export const getChimneyProfileWebsites = (axios, chimDir) => axios.get(`${urlChimneyProfile}/${encodeURIComponent(chimDir)}/links`);

export const getGenreUserFavorites = (axios, dir) => axios.get(`${urlChimneyProfile}/${dir}/genre/favorites`);
export const getArtistUserFavorites = (axios, dir) => axios.get(`${urlChimneyProfile}/${dir}/artist/favorites`);
export const getChimneyProfileTracks = (axios, chimDir, page = 1) =>
  axios.get(`${urlChimneyProfile}/${encodeURIComponent(chimDir)}/tracks?page=${page}&total=yes`);

export const getChimneyProfileTracksByYear = (axios, chimDir, year) =>
  axios.get(`${urlChimneyProfile}/${encodeURIComponent(chimDir)}/year/${year}`);
// https://www.dreamchimney.com/api/tracks/profile/ryan/year/2020

export const getChimneyFavoriteTracks = (axios, chimDir, page = 1) =>
  axios.post(`${urlChimneyProfile}/${encodeURIComponent(chimDir)}/favorites/page/${page}`);

/**
 *
 * http://www.dreamchimney.com/api/tracks/profile/ryan/topten
 * http://www.dreamchimney.com/api/tracks/profile/ryan/wishlist
 * http://www.dreamchimney.com/api/tracks/profile/ryan/links
 * http://www.dreamchimney.com/api/tracks/profile/ryan/tracks
 * http://www.dreamchimney.com/api/tracks/profile/ryan/favorites/page/1
 *
 * @TODO
 * http://www.dreamchimney.com/api/tracks/profile/ryan/year/2019
 */
